import { authcallApipost } from "../../../common/API/Api";
let cachedTimezone = null;

const gettimezoneprefrence = async () => {
  try {
    let postdata = {};
    let res = await authcallApipost(
      postdata,
      `api/preference?key=timezoneshow`,
      "GET"
    );
    if (res?.data?.success) {
      const parsedValue = JSON.parse(res?.data.value);
      return parsedValue;
    }
  } catch (err) {
    console.log(err, "err");
  }
};

export async function convertFormatted(utcString) {
  try {
    const updatetimezone = await gettimezoneprefrence();
    if (!utcString || !updatetimezone) return;
    let utcDate;
    if (utcString.includes("T")) {
      utcDate = new Date(utcString);
    } else {
      utcDate = new Date(utcString + " UTC");
    }
    if (isNaN(utcDate)) return "";
    const formatter = new Intl.DateTimeFormat("en-GB", {
      timeZone: updatetimezone.timezone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
    const parts = formatter.formatToParts(utcDate);
    const getPart = (type) => parts.find((p) => p.type === type)?.value;
    let object  = {
        success:true,
          time: `${getPart("year")}-${getPart("month")}-${getPart("day")} ${getPart(
        "hour"
      )}:${getPart("minute")}:${getPart("second")}`,
    }

   return object
  } catch (err) {
    console.log(err, "err");
  }
}

export function convertLocalToUTCFormatted(utcString, updatetimezone) {
  if (!updatetimezone || !utcString) return;

  // Normalize both formats (with or without 'T'/'Z')
  let clean = utcString.trim();
  clean = clean.replace("T", " ");
  clean = clean.replace("Z", "");
  clean = clean.split(".")[0]; // remove milliseconds if any

  const [datePart, timePart] = clean.split(" ");
  if (!datePart || !timePart) return "";

  const [year, month, day] = datePart.split("-").map(Number);
  const [hour, minute, second] = timePart.split(":").map(Number);

  // Convert to UTC milliseconds
  const utcMs = Date.UTC(year, month - 1, day, hour, minute, second);

  // Apply timezone offset manually
  const offsetSign = updatetimezone.plus === "+" ? 1 : -1;
  const offsetHours = parseInt(updatetimezone.haur, 10) || 0;
  const offsetMinutes = parseInt(updatetimezone.minute, 10) || 0;
  const totalOffsetMs = offsetSign * (offsetHours * 60 + offsetMinutes) * 60 * 1000;
  const localMs = utcMs + totalOffsetMs;

  // Calculate local date/time manually
  const totalSeconds = Math.floor(localMs / 1000);
  const secInDay = 24 * 60 * 60;
  let daysSinceEpoch = Math.floor(totalSeconds / secInDay);
  let secondsOfDay = ((totalSeconds % secInDay) + secInDay) % secInDay;

  const localHour24 = Math.floor(secondsOfDay / 3600);
  secondsOfDay %= 3600;
  const localMinute = Math.floor(secondsOfDay / 60);
  const localSecond = secondsOfDay % 60;

  // Convert daysSinceEpoch → Y/M/D manually
  const daysToDate = (days) => {
    let year = 1970;
    const daysInYear = (y) => (y % 4 === 0 && (y % 100 !== 0 || y % 400 === 0)) ? 366 : 365;
    while (days >= daysInYear(year)) {
      days -= daysInYear(year);
      year++;
    }

    const monthDays = [31, (daysInYear(year) === 366 ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    let month = 0;
    while (days >= monthDays[month]) {
      days -= monthDays[month];
      month++;
    }

    return { year, month: month + 1, day: days + 1 };
  };

  const localDate = daysToDate(daysSinceEpoch);
  const pad = (n) => n.toString().padStart(2, "0");

  // Create 12-hour format with AM/PM
  const hour12 = localHour24 % 12 === 0 ? 12 : localHour24 % 12;
  const ampm = localHour24 >= 12 ? "PM" : "AM";

  // Month short names
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
                      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const allobj = {
    all: `${pad(localHour24)}:${pad(localMinute)}:${pad(localSecond)}`,
    timemin: `${pad(localHour24)}:${pad(localMinute)}`,
    datetime: `${localDate.year}-${pad(localDate.month)}-${pad(localDate.day)} ${pad(localHour24)}:${pad(localMinute)}:${pad(localSecond)}`,
    formatted: `${monthNames[localDate.month - 1]} ${localDate.day}, ${localDate.year}, ${hour12}:${pad(localMinute)} ${ampm}`
  };

  return allobj;
}